;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.filters')
    .filter('graphAxis', GraphAxisFilter)

  GraphAxisFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function GraphAxisFilter (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return function (input) {
      switch (input) {
        case 'client':
          return 'Client'
        case 'date':
          return 'Date d\'émission'
        case 'dueDate':
          return 'Date d\'échéance'
        case 'status':
          return 'État'
        case 'category':
          return 'Catégorie'
        case 'tag':
          return 'Tag'
        case 'referer':
          return 'Référent'
        default:
          return input
      }
    }
  }
})(window.angular, window._)
